import React from 'react';
import { ShopifyAuthContainer, ShopifyAppType } from './ShopifyAuthContainer';

export default function ShopifyRetailerAuthContainer() {
  return <ShopifyAuthContainer shopifyAppType={ShopifyAppType.RETAILER} />;
}
